import { useState } from 'react'
import differenceBy from 'lodash-es/differenceBy'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../constants/common'
import { useScrollIntoView } from '../useScrollIntoView'

export function useScrollToInlineNotifications({
  initialNotifications = EMPTY_LIST,
  notifications = EMPTY_LIST,
} = EMPTY_OBJECT) {
  const [scrollToNotifications, setScrollToNotifications] = useState(0)

  const blockedCount = differenceBy(
    notifications,
    initialNotifications,
    'id'
  ).length

  const { ref } = useScrollIntoView({
    dependency: scrollToNotifications,
  })

  return {
    blockedCount,
    hasBlockedNotifications: blockedCount > 0,
    ref,
    setScrollToNotifications,
  }
}
